import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../app.settings';
import { IBankCredentialsModalComponent } from '../ibank-credentials-modal/ibank-credentials-modal.component';

@Component({
	selector: 'register-user-modal',
	template: require('./register-user-modal.component.html'),
})
export class RegisterUserModalComponent implements OnInit {
	public type: string = 'android';
	public isCustomerOnboardingEnabled: boolean = AppSettings.isCustOnboardingEnabled;
	public createCredentialsBtnText: string;
	public actionText: string;
	public isRebrading = AppSettings.isRebrading;

	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {}

	ngOnInit(): void {
		this.initiateState();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public changeQr(type: string) {
		this.type = type;
	}

	public createCredentials(): void {
		this.isCustomerOnboardingEnabled
			? this.toggleIBankCredentials()
			: this.learnMore('register-ibank');
	}

	public learnMore(type: string) {
		switch (type) {
			case 'register-nbg':
				window.open('https://microsites.nbg.gr/CustomeronBoarding/index.html', '_blank');
				break;
			case 'register-ibank':
				window.open('https://microsites.nbg.gr/mobilebanking/index_CO.html', '_blank');
				break;
		}
	}

	public toggleIBankCredentials(): void {
		this.activeModal.close();
		this.modalService.open(IBankCredentialsModalComponent, {
			windowClass: 'modal-small',
		});
	}

	private initiateState() {
		if (this.isCustomerOnboardingEnabled) {
			this.createCredentialsBtnText = 'Απόκτηση τώρα';
			this.actionText = 'Πλέον μπορείτε να εγγραφείτε online, σε λίγα μόνο βήματα';
		} else {
			this.createCredentialsBtnText = 'Μάθετε περισσότερα';
			this.actionText =
				'Πλέον μπορείτε σε λίγα βήματα να εγγραφείτε στο Internet Banking μέσω της εφαρμογής NBG Mobile Banking';
		}
	}
}
